import Api from '@/_helpers/Api'
import { enqueueSnackbar } from 'notistack'
import React, { createContext, useContext, useEffect, useState } from 'react'

const NotesContext = createContext()

export const useNotesContext = () => {
    const context = useContext(NotesContext)
    if (!context) {
        throw new Error('useNotes must be used within a NotesProvider')
    }
    return context
}

export const NotesProvider = ({ children }) => {
    const [todo, setTodo] = useState({
        loading: true,
        data: [],
        total: 0,
        pages: 0,
        page: 1,
        filter: {},
        setFilter: false,
        update: false,
    })

    useEffect(() => {
        loadTodos()
    }, [])

    const handleRead = id => {
        Api.post('todos/mark-as-read', {
            id: id
        })
    }

    const handleRemoveFromTray = id => {
        setTodo(prev => ({
            ...prev,
            loading: true
        }))

        Api.post(`todos/tray/unminimize`, { id })
            .then(() => {
                loadTodos()
                enqueueSnackbar(`Бележката беше премахната от минимизираните!`, {
                    variant: "success",
                })
            })
    }

    const handleAddToTray = id => {
        setTodo(prev => ({
            ...prev,
            loading: true
        }))

        Api.post(`todos/tray/minimize`, { id })
            .then(() => {
                loadTodos()
                enqueueSnackbar(`Бележката беше минимизирана!`, {
                    variant: "success",
                })
            })
    }

    function loadTodos() {
        if (!todo.loading) {
            setTodo(prev => ({
                ...prev,
                loading: true
            }))
        }

        Api.get('todos/tray/all')
            .then(res => {
                if (res.data.length > 0) {
                    document.querySelector('.App > main > section').style.paddingBottom = '107px'
                } else {
                    document.querySelector('.App > main > section').style.paddingBottom = '15px'
                }

                setTodo(prev => ({
                    ...prev,
                    data: res.data,
                }))
            })
            .finally(() => {
                setTodo(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    // TO DO: след като заявката се оправи, филтъра няма да е нужен
    const getMinimizedTodos = () => todo.data

    const value = {
        todo,
        handleAddToTray,
        handleRemoveFromTray,
        getMinimizedTodos,
        loadingTray: todo.loading,
        handleRead
    }

    return (
        <NotesContext.Provider value={value}>
            {children}
        </NotesContext.Provider>
    )
}